/**
 * Chat-Komponente — wiederverwendbar (Lobby/Game).
 *
 * WARUM eigene Komponente: Wird in mehreren Screens genutzt.
 * SRP: nur Anzeige + Eingabe, kein State außer Message-List.
 */
import { el, div, button, input } from '../../utils/domHelpers.js';
import { socketService } from '../../services/socketService.js';
import { eventBus } from '../../core/eventBus.js';
import { getInitials } from '../../utils/formatters.js';

const MAX_MESSAGES = 50;       // Backlog-Limit fürs DOM

export function createChat(myPlayerId) {
  const messages = [];
  const listEl  = div({ class: 'chat-list' });
  const inputEl = input({
    class: 'glass-input chat-input',
    type: 'text',
    placeholder: 'Nachricht...',
    maxlength: 200,
  });

  // Auto-Scroll nur wenn der Nutzer am unteren Rand ist (sonst unterbrechen wir das Scrollen)
  function isAtBottom() {
    return listEl.scrollHeight - listEl.scrollTop - listEl.clientHeight < 30;
  }

  function appendMessage({ playerId, playerName, text, timestamp, isSystem }) {
    const wasAtBottom = isAtBottom();
    const isMine = playerId === myPlayerId;

    const node = div({
      class: `chat-msg${isMine ? ' chat-msg--mine' : ''}${isSystem ? ' chat-msg--system' : ''}`
    }, [
      !isSystem && div({ class: 'chat-avatar' }, [getInitials(playerName)]),
      div({ class: 'chat-body' }, [
        !isSystem && div({ class: 'chat-meta mono' }, [
          el('span', { class: 'chat-name' }, [playerName]),
        ]),
        div({ class: 'chat-text' }, [text]),
      ]),
    ]);

    listEl.appendChild(node);
    messages.push({ playerId, text, timestamp });

    // DOM nicht ins Endlose wachsen lassen
    while (listEl.children.length > MAX_MESSAGES) listEl.firstChild.remove();
    if (wasAtBottom) listEl.scrollTop = listEl.scrollHeight;
  }

  function send() {
    const text = inputEl.value.trim();
    if (!text) return;
    socketService.send('chat_message', { text });
    inputEl.value = '';
  }

  // Tastatur: Enter schickt
  inputEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); send(); }
  });

  // Server-Events abonnieren
  const off = eventBus.on('server:chat_message', appendMessage);
  // Cleanup beim Routenwechsel
  eventBus.on('route:before-change', () => off());

  // Welcome-System-Message
  appendMessage({
    playerName: '', text: 'Chat gestartet — Enter zum Senden',
    timestamp: Date.now(), isSystem: true,
  });

  // Public API
  return {
    node: div({ class: 'chat-container' }, [
      div({ class: 'chat-header mono' }, [
        el('span', { class: 'badge' }, ['💬 CHAT'])
      ]),
      listEl,
      div({ class: 'chat-input-row' }, [
        inputEl,
        button({ class: 'btn btn-primary btn-sm', onclick: send }, ['↵']),
      ]),
    ]),
    appendSystemMessage: (text) =>
      appendMessage({ playerName: '', text, timestamp: Date.now(), isSystem: true }),
  };
}
